module.exports = __webpack_public_path__ + "img/Kyoutai_romakyun.989b55ba.png";